import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

const GENERAL_PRACTITIONER_PATH = 'generalPractitioner'

//#region Page
export function getPageGeneralPractitioners(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${GENERAL_PRACTITIONER_PATH}/getPage`,
            filterRequest,
            {
                params: {
                    userId,
                    pageNumber,
                    pageRows,
                    sortField,
                    sortOrder,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region List
export function getListGeneralPractitioners(userId, dto, filterRequest) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${GENERAL_PRACTITIONER_PATH}/getList`,
            filterRequest,
            {
                params: {
                    userId,
                    dto,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Create Or Update
export function createOrUpdateGeneralPractitioner(userId, data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${GENERAL_PRACTITIONER_PATH}/createOrUpdate`,
            data,
            {
                params: {
                    userId,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Delete
export function deleteGeneralPractitioner(userId, id) {
    return axiosInstance
        .delete(`${BACKEND_ENDPOINT}/${GENERAL_PRACTITIONER_PATH}/deleteById`, {
            params: {userId, id},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Get By Id
export function getDetailGeneralPractitioner(userId, id) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${GENERAL_PRACTITIONER_PATH}/getById`, {
            params: {
                userId,
                id,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion
